import React, { VFC } from 'react';
import { StyleSheet, View } from 'react-native';
import { getSpacing, ItemCard, Tag, Text } from '@rahtab/ui';
import { Stock } from 'rahtab-redux/slices/stockListSlice';
import { withSeparator, withToman } from '@rahtab/system/lib/tools/string';
import moment from 'moment-jalaali';

const StockListItem: VFC<Stock & { assignFinalCode: string }> = ({
  saleAmount,
  status,
  statusText,
  stockAmount,
  stockDate,
  stockCode,
  stockPrice,
  stopReason,
  assignFinalCode,
  stopDate,
  salePercent,
  unitText,
}) => {
  const isActive = status === 1;
  return (
    <ItemCard
      hasChevron={isActive}
      screenName="StopStock"
      params={{
        assignFinalCode,
        stockCode,
      }}
      caption={
        <Text margin="none" color="description">
          {isActive ? 'توقف عرضه' : 'زمان توقف عرضه: '}
          <Text margin="none">{isActive ? '' : moment(stopDate).format('HH:mm | jYYYY/jMM/jDD')}</Text>
        </Text>
      }>
      <View style={styles.firstRow}>
        <Text margin="none" color="description">
          عرضه بار در تاریخ
          <Text margin="none"> {moment(stockDate).format('HH:mm | jYYYY/jMM/jDD')}</Text>
        </Text>
        <Tag text={statusText} backgroundColor={isActive ? 'green' : 'secondary'} color="white" margin="none" />
      </View>
      <Text color="description">
        مقدار:
        <Text>
          {' '}
          {withSeparator(stockAmount)} {unitText}
        </Text>
      </Text>
      <Text color="description">
        قیمت مصرف کننده:
        <Text> {withToman(stockPrice)}</Text>
      </Text>
      <Text color="description" margin={isActive ? 'none' : 'default'}>
        مقدار فروش:
        <Text>
          {' '}
          {withSeparator(saleAmount)} {unitText} ({salePercent}٪)
        </Text>
      </Text>
      {!isActive && (
        <Text color="description" margin="none">
          علت توقف: <Text>{stopReason}</Text>
        </Text>
      )}
    </ItemCard>
  );
};

export default StockListItem;

const styles = StyleSheet.create({
  firstRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: getSpacing(0.5),
  },
});

enum Status {
  'active',
  'stopped',
}
